const action = require('../action/action');

// Fetches a controller action's components + actions over XHR and renders them into a
// surface (see themes/base/components/surface). Which surface is the action's own choice,
// carried in its extra attributes:
//   surface: 'modal'      (default) a body-level dialog; modalSize 'fullscreen' covers the page
//   surface: 'container'  an inlineSurface dropped into the container component named by
//                         surfaceTarget, rendering the form in place on the page
const popupEdit = Object.assign({}, action, {
    surface: false,
    noHeader: false,
    noFooter: false,

    act: async function () {
        if (this.disabled) {
            return false;
        }

        this.element.setAttribute("data-zit-indicator", "on");

        if (this.surface !== false && this.surface.needsRebuild()) {
            this.surface.dispose();
            this.surface = false;
        }

        if (this.surface === false) {
            await this.createSurface();
        }

        this.surface.open();

        this.element.removeAttribute("data-zit-indicator");
    },

    createSurface: async function () {
        let formId = 'popupEditForm_' + this.id;
        formId = formId.replace(this.formId + '_', '');

        let formPostData = {
            csrf: this.hm.app.pageToken,
            formId: formId
        };

        if (this.itemId !== null) {
            formPostData.id = this.itemId;
        }

        formPostData = Object.assign({}, formPostData, this.postParams);

        //this.hm.log('create surface', this.controller, this.action, formPostData);

        let response = await this.hm.app.fetchJson(this.controller, this.action, formPostData, 'POST');

        this.surface = this.newSurface();

        // Before initComponents(): the components adopt this form id (stampFormId below) and
        // an inline surface's controls resolve their form owner by it, so the form has to
        // carry the id already.
        this.surface.initForm(formId);

        if (typeof response._pageTitle !== typeof undefined) {
            this.surface.setTitle(response._pageTitle);
        } else {
            this.surface.setTitle(this.element.title);
        }

        let surfaceContent = document.createElement('div');

        this.hm.app.addComponentsFromRemoteResponse(surfaceContent, response);

        this.surface.appendContent(surfaceContent);

        // Every actions group is placed at the surface position named after it: one of the
        // surface's own action zones (footerLeft/footerRight, plus headerRight on a modal), or
        // the name of a container component in the content just added. A container's rendered
        // html id is prefixed with the form id, so the position has to be prefixed the same
        // way to name it. 'general' goes to the surface's default position.
        for (let position in response.actions) {
            this.surface.addActions(response.actions[position], this.surfacePosition(position, formId));
        }

        this.surface.stampFormId(formId);
        this.surface.watchActions();

        this.hm.app.initComponents(this.surface.element);

        this.hm.app.externalScriptsFromRemoteResponse(response);
    },

    // Build the surface this action asked for. A 'container' surface names a container
    // component on the page that rendered THIS action — so its html id carries the form id
    // this action itself belongs to, not the one generated for the response. (The two id
    // spaces are distinct: see surfacePosition, which prefixes with the response's form id.)
    // A container that is missing or not a container falls back to a modal rather than
    // swallowing the action.
    newSurface: function () {
        let surfaceType = typeof this.extraAttributes.surface !== typeof undefined ? this.extraAttributes.surface : 'modal';

        if (surfaceType === 'container') {
            let containerId = (this.formId ? this.formId + '_' : '') + this.extraAttributes.surfaceTarget;
            let container = this.hm.app.getComponent(containerId);

            if (container !== false && typeof container.addElement !== typeof undefined) {
                let inlineSurface = this.hm.newComponent('inlineSurface');
                inlineSurface.init({ container: container });
                inlineSurface.inited();

                return inlineSurface;
            }

            this.hm.warn('popupEdit ' + this.id + ': no container component "' + containerId + '"; falling back to a modal');
        }

        let noHeader = typeof this.extraAttributes.noHeader !== typeof undefined ? this.extraAttributes.noHeader : this.noHeader;
        let noFooter = typeof this.extraAttributes.noFooter !== typeof undefined ? this.extraAttributes.noFooter : this.noFooter;

        let modal = this.hm.newComponent('modal');
        modal.init({ noHeader: noHeader, noFooter: noFooter });
        modal.inited();

        let modalSize = typeof this.extraAttributes.modalSize !== typeof undefined ? this.extraAttributes.modalSize : 'lg';

        modal.setSize(modalSize);

        return modal;
    },

    // Translate a server-side actions group into a surface position: 'general' means the
    // surface's default position (false), one of its action zones passes through untouched,
    // and anything else names a container component in the response's components — its html
    // id carries the form id prefix that component::get_html_id() built it with.
    surfacePosition: function (position, formId) {
        if (position === 'general') {
            return false;
        }

        if (this.surface.positions.indexOf(position) !== -1) {
            return position;
        }

        return formId + '_' + position;
    }
});

module.exports = popupEdit;
